export default __webpack_public_path__ + "static/media/speedometer.416b556b.png";